import gql from "graphql-tag";

export const importFromTemplate = gql`
  mutation ImportFromTemplate($input: ImportFromTemplateRequestInput) {
    ImportFromTemplate(input: $input) {
      portId
    }
  }
`;
